var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 163,
    viewBox: "0 0 169 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.284 162.587C116.953 162.727 116.621 162.865 116.288 163H52.7122C52.3791 162.865 52.0471 162.727 51.7161 162.587H117.284Z",
    fill: "#F3B0AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.854 155.985H39.1462C38.5123 155.58 37.8841 155.168 37.2618 154.747H131.738C131.116 155.168 130.488 155.58 129.854 155.985Z",
    fill: "#F3B0AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9027 146.494C27.5018 147.053 28.1089 147.603 28.7239 148.144H140.276C140.891 147.603 141.498 147.053 142.097 146.494H26.9027Z",
    fill: "#F3B0AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9081 140.304C20.198 139.492 19.5032 138.667 18.824 137.828H150.176C149.497 138.667 148.802 139.492 148.092 140.304H20.9081Z",
    fill: "#F3B0AE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6638 129.162C13.2695 130.138 13.8944 131.101 14.5381 132.051H154.462C155.106 131.101 155.731 130.138 156.336 129.162H12.6638Z",
    fill: "#F3B0AE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9667 122.56C8.35301 121.338 7.768 120.1 7.21256 118.846H161.787C161.232 120.1 160.647 121.338 160.033 122.56H8.9667Z",
    fill: "#F3B0AE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55203 108.942C3.88473 110.052 4.23959 111.153 4.61611 112.243H164.384C164.76 111.153 165.115 110.052 165.448 108.942H3.55203Z",
    fill: "#F3B0AE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04225 103.165C1.76749 101.936 1.51941 100.698 1.29865 99.4506H167.701C167.481 100.698 167.232 101.936 166.958 103.165H2.04225Z",
    fill: "#F3B0AE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.142365 89.5469C0.238304 91.2108 0.382285 92.8619 0.572938 94.4987H168.427C168.618 92.8619 168.762 91.2108 168.858 89.5469H0.142365Z",
    fill: "#F3B0AE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000984176 85.0076C0.000328306 84.8701 0 84.7326 0 84.5949C0 83.0721 0.0401918 81.5587 0.119571 80.0557H168.88C168.96 81.5587 169 83.0721 169 84.5949C169 84.7326 169 84.8701 168.999 85.0076H0.000984176Z",
    fill: "#F3B0AE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08908 70.9772C0.824729 72.6126 0.607206 74.2637 0.437937 75.9291H168.562C168.393 74.2637 168.175 72.6126 167.911 70.9772H1.08908Z",
    fill: "#F3B0AE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77506 67.2633C2.06379 65.875 2.38651 64.4991 2.74232 63.1367H166.258C166.613 64.4991 166.936 65.875 167.225 67.2633H1.77506Z",
    fill: "#F3B0AE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67302 54.0582C4.94056 55.9519 4.27423 57.8786 3.67685 59.8354H165.323C164.726 57.8786 164.059 55.9519 163.327 54.0582H5.67302Z",
    fill: "#F3B0AE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67618 51.5823C7.38774 49.9032 8.15193 48.2519 8.96668 46.6304H160.033C160.848 48.2519 161.612 49.9032 162.324 51.5823H6.67618Z",
    fill: "#F3B0AE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9854 37.9646C12.6598 39.9697 11.4172 42.0346 10.2626 44.1544H158.737C157.583 42.0346 156.34 39.9697 155.015 37.9646H13.9854Z",
    fill: "#F3B0AE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3937 35.9013C17.1096 33.465 18.9509 31.1234 20.9081 28.8861H148.092C150.049 31.1234 151.89 33.465 153.606 35.9013H15.3937Z",
    fill: "#F3B0AE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1962 20.6329C26.8065 22.7056 24.5342 24.9102 22.3905 27.2355H146.61C144.466 24.9102 142.193 22.7056 139.804 20.6329H29.1962Z",
    fill: "#F3B0AE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6564 19.395C45.2766 7.28048 64.039 0 84.5 0C104.961 0 123.723 7.28048 138.344 19.395H30.6564Z",
    fill: "#F3B0AE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.462319d6dd1cd370858e66ccfefbbf75.svg";
export { ForwardRef as ReactComponent };